// Mount the Hosting module: hand `createHostingModule` a lazy host (`./hosting-host`, which holds the
// heavy app imports) instead of a built one, as `register-mail.tsx` does. `service-modules.ts` and
// `service-scopes.ts` take the routes and the catalog scopes from HERE. This file must stay light: it
// is in the entry chunk.
import { createHostingModule } from '@vnetwork/margarita-hosting';

export const hosting = createHostingModule(() => import('./hosting-host').then((m) => m.hostingHost));
